import { TApplicationState } from '../../types/referrer/store';

export const selectUserId = (state: TApplicationState) => state.user.userId;

export const selectUserPhone = (state: TApplicationState) => state.user.phoneNumber;
